import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

const NewDefaultInput = ({
                             className,
                             label,
                             readOnly,
                             placeholder,
                             type,
                             size,
                             field,
                             disabled,
                             isRequired,
                             validate,
                             value,
                             prependData,
                             inputClassName,
                             form: {touched, errors},
                             ...props
                         }) => {

    const classes = cx(
        'form-field',
        touched[field.name] && errors[field.name] && 'form-field--error',
        `form-field--${size}`,
        disabled && `form-field--disabled`,
        value && 'form-field--active',
        className
    );
    const isPriceField = field.name && ['tariff_price', 'tariff_price_sum'].includes(field.name);

    const formatNumber = (val) => {
        if (!val && val !== 0) return "";
        return val.toString().replace(/\s/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    };

    return (
        <div className={classes}>
            {label && (
                <label className="form-field__label">
                    {label}
                    {isRequired && <span title={"Обязательный поля"}>*</span>}
                </label>
            )}
            <div className="input-group">
                <input
                    className={`form-field__input-new ${inputClassName}`}
                    readOnly={readOnly}
                    disabled={disabled}
                    {...{placeholder}}
                    {...field}
                    {...props}
                    type={isPriceField ? "text" : type}
                    value={isPriceField ? formatNumber(field.value) : field.value}
                />
                {prependData && prependData}
            </div>
        </div>
    );
};

NewDefaultInput.propTypes = {
    label: PropTypes.string,
    type: PropTypes.oneOf(["text", "password", "number"]),
    className: PropTypes.string,
    placeholder: PropTypes.string,
    inputClassName: PropTypes.string,
    readOnly: PropTypes.bool,
    size: PropTypes.oneOf(["default", "large", "small", "extra-small"]),
    disabled: PropTypes.bool,
    isRequired: PropTypes.bool,
};

NewDefaultInput.defaultProps = {
    label: "",
    placeholder: "",
    inputClassName: "",
    type: "text",
    className: null,
    readOnly: false,
    disabled: false,
    isRequired: false,
    size: "default",
};

export default NewDefaultInput;
